"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryServiceClientImpl = exports.MsgServiceClientImpl = exports.protobufPackage = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const tx_1 = require("./tx");
exports.protobufPackage = "axelar.tss.v1beta1";
class MsgServiceClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || "axelar.tss.v1beta1.MsgService";
        this.rpc = rpc;
        this.HeartBeat = this.HeartBeat.bind(this);
    }
    HeartBeat(request) {
        const data = tx_1.HeartBeatRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "HeartBeat", data);
        return promise.then((data) => tx_1.HeartBeatResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgServiceClientImpl = MsgServiceClientImpl;
class QueryServiceClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || "axelar.tss.v1beta1.QueryService";
        this.rpc = rpc;
    }
}
exports.QueryServiceClientImpl = QueryServiceClientImpl;
